import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, withRouter, Link } from 'react-router-dom';
import NlpProjectSettings from './NlpProjectSettings';
import Demo from './NlpDemoTabs';
import Deploy from './NlpDeployTab'
import $ from 'jquery';
import NlpUsageTab from './NlpUsageTab';
import NLPMultiLingualTabs from './NLPMultiLingualTabs';

class NlpLeftPanel extends Component {

  componentDidMount() {
    (function () {
      var currentPath = window.location.href;
      var projectSettingsPathExist = false;
      var projectSettingsTabsPatterns = ['/api-keys'];
      for (var i = 0; i < projectSettingsTabsPatterns.length; i++) {
        if (currentPath.includes(projectSettingsTabsPatterns[i]) == true) {
          projectSettingsPathExist = true;
          break;
        }
      }
      var path = window.origin + "/platform/cloud-nlp/";
      var path1 = window.origin + "/platform/cloud-nlp";
      if (currentPath == path || currentPath == path1 || projectSettingsPathExist) {
        $("#left-panel-menu-projectSettings").addClass('activemenu');
      } else if (currentPath.includes('/demo')) {
        $("#left-panel-menu-demo").addClass('activemenu');
      } else if (currentPath.includes('/nlutab')) {
        $("#left-panel-menu-usage").addClass('activemenu');
      }else if (currentPath.includes('/entities')) {
        $("#left-panel-menu-entities").addClass('activemenu');
      }else if (currentPath.includes('/deploy')) {
        $("#left-panel-menu-deploy").addClass('activemenu');
      }else {
        $("#" + localStorage.getItem("last-used-left-panel-tab")).addClass('activemenu')
      }
      $("#left-panel-menu-projectSettings,#left-panel-menu-demo,#left-panel-menu-entities,#left-panel-menu-usage,#left-panel-menu-deploy")
        .on("click", function () {
          $("#left-panel-menu-projectSettings,#left-panel-menu-demo,#left-panel-menu-entities,#left-panel-menu-usage,#left-panel-menu-deploy")
            .removeClass('activemenu');
          localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
          $(this).addClass('activemenu')

        })

    })();
  }
  render() {
    return (
      <Router basename={window.contextPath}>
        <div>
          <link rel="stylesheet" href="./plugins/font-awesome/css/font-awesome.min.css" />
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="./assets/css/adminlte.css" />
          <link rel="stylesheet" href="./assets/css/styles.css" />
          <link rel="stylesheet" href="./assets/css/custom-style.css" />
          <link rel="stylesheet" href="./plugins/iCheck/all.css" />
          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link href="assets/css/scrollbar.css" rel="stylesheet" />
          <div className="content-wrapper">
            <div className="left-menu" style={{ marginTop: '0px', position: "absolute" }} >
              <ul id="floatMenu">
                <Link to="/cloud-nlp">
                  <li id="left-panel-menu-projectSettings" className="tabs">
                    <i className="fa flaticon-ui" /><span>NLP API Settings</span>
                  </li>
                </Link>
                <Link to="/cloud-nlp/demo">
                  <li id="left-panel-menu-demo" className="tabs">
                    <i className="fa flaticon-ui" /><span>Demo</span>
                  </li>
                </Link>
                <Link to="/cloud-nlp/entities">
                 <li id="left-panel-menu-entities" className="tabs">
                    <i className="fa flaticon-ui" /><span>Entities</span>
                  </li></Link>
                {/* <Link to="/cloud-nlp/usage">
                 <li id="left-panel-menu-usage" className="tabs">
                    <i className="fa flaticon-ui" /><span>Usage</span>
                  </li></Link>
                  <Link to="/cloud-nlp/deploy">
                 <li id="left-panel-menu-deploy" className="tabs">
                    <i className="fa flaticon-ui" /><span>Deploy</span>
                  </li></Link> */}
                </ul>
            </div>
          </div>
          <Switch>
          <Route path="/cloud-nlp/entities" component={NLPMultiLingualTabs}></Route>
          <Route path="/cloud-nlp/usage" component={NlpUsageTab}></Route>
          <Route path="/cloud-nlp/demo" component={Demo}></Route>
          <Route path="/cloud-nlp/deploy" component={Deploy}></Route>
           <Route path="/cloud-nlp" component={NlpProjectSettings}></Route>



          </Switch>
        </div>
      </Router>
    );
  }
}
export default NlpLeftPanel;


// WEBPACK FOOTER //
// ./src/nlpUi/NlpLeftPanel.js